import { createIcon } from '../shared'

const CommentIcon = createIcon(
  ({ color }) => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8868 12C21.8868 6.47715 17.435 2 11.9434 2C6.45182 2 2 6.47715 2 12C2 17.5228 6.45182 22 11.9434 22C13.9072 22 15.74 21.4266 17.2828 20.4373L20.4543 21.5537C21.3789 21.8791 22.2635 20.9768 21.927 20.0517L20.7136 16.7161C21.4624 15.3105 21.8868 13.704 21.8868 12ZM11.9434 3.66667C16.5197 3.66667 20.2296 7.39763 20.2296 12C20.2296 13.5415 19.8142 14.9829 19.0903 16.2199C18.9646 16.4347 18.9411 16.6948 19.0263 16.9288L20.0094 19.6313L17.4401 18.7269C17.1883 18.6383 16.9095 18.677 16.691 18.8309C15.3467 19.7778 13.7108 20.3333 11.9434 20.3333C7.36708 20.3333 3.65723 16.6024 3.65723 12C3.65723 7.39763 7.36708 3.66667 11.9434 3.66667Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'FacebookCommentIcon',
)

export { CommentIcon }
